const executionAmount = {
  state: {
    pageType: '',
    moduleType: '',
    beginUpdate: 1,
    reloadList: 1, // 重新加载列表
    transactionReconciliationQuery: {
      queryType: 1,
      billStatus: -1,
      keyword: '',
      startDate: '',
      endDate: '',
      companyId: 0,
      feeType: -1
    },

    detailBean: 0, // 对账详情实体
    maintenanceReconciliationQuery: {},
    notAllowReconciliationQuantity: 0 // 不允许对账条目的勾选数量
  },
  mutations: {
    set_executionAmount_pageType (state, data) {
      state.pageType = data
    },
    set_executionAmount_moduleType (state, data) {
      state.moduleType = data
    },
    set_executionAmount_update (state, data) {
      state.beginUpdate = data
    },
    set_executionAmount_reloadList (state, data) {
      state.reloadList = data
    },
    set_executionAmount_transactionReconciliationQuery (state, data) {
      state.transactionReconciliationQuery = data
    },
    set_executionAmount_detailBean (state, data) {
      state.detailBean = data
    },
    set_executionAmount_maintenanceReconciliationQuery (state, data) {
      state.maintenanceReconciliationQuery = data
    },
    set_executionAmount_notAllowReconciliationQuantity (state, data) {
      state.notAllowReconciliationQuantity = data
    }
  },
  getters: {

  },
  actions: {

  }
}

export default executionAmount
